import BaseObjectStore from './base-object.store';

class VideoFeedStore extends BaseObjectStore {
  constructor(props) {
    super(props);
    this.name = 'videoFeed';
  }

  resetAllFields() {
    this.resetAllBaseFields();
  }
}

export default new VideoFeedStore();
